import { useState } from "react";
import { HexColorPicker } from "react-colorful";

type params = {
  color: any;
  setColor: any;
  size?:string;
};
export const ColorPicker = (props: params) => {
  const { color, setColor, size, ...others } = props;
  //   const [color, setColor] = useState("#aabbcc");
  return (
    <>
      <section className={size ?? "colorPickerSmall"}>
      <HexColorPicker color={color} onChange={(e:any)=>setColor(e)} />
      </section>
    </>
  );
};
